import React from "react";
import { StandardVersusResultsPayload, Player } from "../../shared/interfaces/GameLogicTypes";
import { getPlayerColor } from "../PlayerAvatar/PlayerAvatar";
import ResultsDialog from "../ResultsDialog/ResultsDialog";
import MobileResults from "../MobileResults/MobileResults";

export interface VersusResultsProps {
  results: StandardVersusResultsPayload;
  viewerId: string;
  players: { [playerId: string]: Player };
  isMobile?: boolean;
  waitForHost: boolean;
  isHost: boolean;
  isReady: boolean;
  readyPlayerIds: string[];
  totalPlayers: number;
  onReadyToggle: (next: boolean) => void;
}

/**
 * STANDARD_VERSUS compares each real player's answer with the explicit aggregate group ranking.
 * The group is data, not a player or role.
 */
export default function VersusResultsPanel({
  results,
  viewerId,
  players,
  isMobile,
  waitForHost,
  isHost,
  isReady,
  readyPlayerIds,
  totalPlayers,
  onReadyToggle,
}: VersusResultsProps) {
  const allPids = Object.keys(players);
  const laserPlayers = Object.keys(results.results).map((pid) => ({
    id: pid,
    name: results.results[pid]?.playerInfo?.name ?? pid,
    color: getPlayerColor(Math.max(0, allPids.indexOf(pid))),
  }));

  // The shared result renderers accept the aggregate ranking directly; no fake player is added.
  const shared = {
    isTsar: false,
    isHost,
    question: results.question,
    playerId: viewerId,
    results: results.results,
    groupRanking: results.groupRanking,
    cues: results.cues,
    waitForHost,
    readyPlayerIds,
    isReady,
    onReadyToggle,
    totalPlayers,
    laserPlayers,
    isVersus: true,
  };

  if (isMobile) {
    return <MobileResults {...shared} />;
  }
  return <ResultsDialog inline isOpen {...shared} />;
}
